<template>
  <RevLoadingScreen
    data-qa="loading-screen"
    data-test="loading-screen"
    text=""
  />
</template>

<script lang="ts" setup>
import { useLogin } from '@backmarket/nuxt-layer-oauth/useLogin'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'

const logger = useLogger()

useLogin({
  onError(error) {
    if (error instanceof Error) {
      logger.error('Something failed while logging in', { error })
    }
  },
})
</script>
